import { GieliCoordinates, TileCoordinates, TileRectangle } from "../../lib/runescape/coordinates";
import { Vector2 } from "../../lib/math";
import { TileArea } from "../../lib/runescape/coordinates/TileArea";
import { Transportation } from "../../lib/runescape/transportation";
export var ClueTier;
(function (ClueTier) {
    ClueTier.values = ["easy", "medium", "hard", "elite", "master", "tetracompass", "sandy"];
})(ClueTier || (ClueTier = {}));
export var ClueType;
(function (ClueType) {
    function meta(x) {
        let lut = {
            easy: { icon_url: "/assets/icons/sealedeasy.png", name: "Easy" },
            medium: { icon_url: "/assets/icons/sealedmedium.png", name: "Medium" },
            hard: { icon_url: "/assets/icons/sealedhard.png", name: "Hard" },
            elite: { icon_url: "/assets/icons/sealedelite.png", name: "Elite" },
            master: { icon_url: "/assets/icons/sealedmaster.png", name: "Master" },
            tetracompass: { icon_url: "/assets/icons/tetracompass.png", name: "Tetracompass" },
            sandy: { icon_url: "/assets/icons/sandcastle.png", name: "Sandy" },
            anagram: { icon_url: "/assets/icons/activeclue.png", name: "Anagram" },
            compass: { icon_url: "/assets/icons/arrow.png", name: "Compass" },
            coordinates: { icon_url: "/assets/icons/sextant.png", name: "Coordinate" },
            cryptic: { icon_url: "/assets/icons/activeclue.png", name: "Cryptic" },
            emote: { icon_url: "/assets/icons/emotes.png", name: "Emote" },
            map: { icon_url: "/assets/icons/map.png", name: "Map" },
            scan: { icon_url: "/assets/icons/scan.png", name: "Scan" },
            simple: { icon_url: "/assets/icons/activeclue.png", name: "Simple" },
            skilling: { icon_url: "/assets/icons/skills.webp", name: "Skilling" }
        };
        return lut[x];
    }
    ClueType.meta = meta;
    function pretty(x) {
        if (!x)
            return "";
        return x.charAt(0).toUpperCase() + x.slice(1);
    }
    ClueType.pretty = pretty;
    ClueType.all = ["simple", "cryptic", "emote", "map", "anagram", "coordinates", "compass", "scan", "skilling"];
})(ClueType || (ClueType = {}));
export var Clues;
(function (Clues) {
    let Step;
    (function (Step) {
        function solution(step) {
            if (step.solution)
                return step.solution;
            if (step.type == "coordinates")
                return {
                    type: "dig",
                    spot: GieliCoordinates.toCoords(step.coordinates),
                    description: null
                };
            return null;
        }
        Step.solution = solution;
        function shortString(step, text_variant = 0) {
            let i = Math.max(0, Math.min(step.text.length - 1, text_variant));
            switch (step.type) {
                case "anagram":
                    return `Anagram: ${step.anagram[i]}`;
                case "map":
                    return `Map: ${step.text[i]}`;
                case "coordinates":
                    return GieliCoordinates.toString(step.coordinates);
                case "scan":
                    return `Scan ${step.scantext} (${step.range} tiles)`;
                default:
                    return step.text[i];
            }
        }
        Step.shortString = shortString;
    })(Step = Clues.Step || (Clues.Step = {}));
    let ClueSpot;
    (function (ClueSpot) {
        var default_interactive_area = Transportation.EntityTransportation.default_interactive_area;
        let Id;
        (function (Id) {
            function equals(a, b) {
                return a?.clue == b?.clue && ((a?.spot == b?.spot) || TileCoordinates.eq2(a?.spot, b?.spot));
            }
            Id.equals = equals;
        })(Id = ClueSpot.Id || (ClueSpot.Id = {}));
        function shortString(spot, text_variant = 0) {
            if (spot.clue.type == "compass")
                return `Compass spot ${spot.spot ? Vector2.toString(spot.spot) : "???"}`;
            else
                return Step.shortString(spot.clue, text_variant);
        }
        ClueSpot.shortString = shortString;
        function targetArea(spot) {
            if (spot.spot) {
                if (spot.clue.type == "compass" && spot.clue.single_tile_target)
                    return [TileArea.fromTiles([spot.spot])];
                return [digSpotArea(spot.spot)];
            }
            const sol = Clues.Step.solution(spot.clue);
            if (sol) {
                switch (sol.type) {
                    case "search":
                        return [default_interactive_area(sol.spot)];
                    case "dig":
                        return [digSpotArea(sol.spot)];
                    case "talkto":
                        return sol.spots.map(s => s.range);
                }
            }
            if (spot.clue.type == "emote")
                return [spot.clue.area];
            if (spot.clue.type == "scan")
                return [TileArea.fromRect(TileRectangle.from(...spot.clue.spots))];
            if (spot.clue.type == "skilling")
                return spot.clue.areas;
        }
        ClueSpot.targetArea = targetArea;
        function toId(spot) {
            return { clue: spot.clue.id, spot: spot.spot };
        }
        ClueSpot.toId = toId;
        function solution(spot) {
            if (spot.spot)
                return { type: "dig", spot: spot.spot, description: null };
            return Clues.Step.solution(spot.clue);
        }
        ClueSpot.solution = solution;
    })(ClueSpot = Clues.ClueSpot || (Clues.ClueSpot = {}));
    function digSpotArea(spot) {
        return TileArea.fromRect(digSpotRect(spot));
    }
    Clues.digSpotArea = digSpotArea;
    function digSpotRect(spot) {
        return {
            topleft: { x: spot.x - 1, y: spot.y + 1 },
            botright: { x: spot.x + 1, y: spot.y - 1 },
            level: spot.level
        };
    }
    Clues.digSpotRect = digSpotRect;
    function requiresKey(clue) {
        return clue.solution && clue.solution.type == "search" && !!clue.solution.key;
    }
    Clues.requiresKey = requiresKey;
})(Clues || (Clues = {}));
